<template>
  <div class="mt-2">
    <!-- If is children resolution display parent name and number -->
    <div v-if="parentResolutionNumber && parentResolutionName" style="font-size: 15px;">
      <span class="font-italic ml-4">{{ "Résolution n° " + parentResolutionNumber }}</span>
      <span class="font-italic">{{ " - " + parentResolutionName }}.</span>
    </div>
    <!-- This will apply for parent resolution without children and also for children resolution -->
    <div class="d-flex">
      <div>
        <span class="mr-1">{{ voteOrder }})</span>
      </div>
      <div>
        <span v-if="!parentResolutionNumber && !parentResolutionName">Résolution n°</span>
        <span v-else>Sous résolution n°</span
        ><span v-if="parentResolutionNumber">{{ parentResolutionNumber }}.</span
        >{{ resolution.resolution_number }} - {{ resolution.name }}
        <span v-if="resolution.majority_id" class="font-italic">
          <span v-if="resolution.majority_id != defaultSansVoteMajorityId">
            - Majorité : {{ majorityName }}
          </span>
          <span v-if="resolution.majority_id == defaultSansVoteMajorityId"
            >- {{ majorityName }}</span
          >
          <span
            v-if="
              resolution.voting_category_id && resolution.majority_id != defaultSansVoteMajorityId
            "
          >
            &nbsp; - Clé de vote : {{ findVotingCategoryData(resolution.voting_category_id).name }}
          </span>
        </span>
        <span v-else class="text-danger">majorité non définie</span>
        <span v-if="resolution.status == meetingResolutionStatuses.accepted">
          <font-awesome-icon
            icon="check"
            class="text-success pl-3"
            size="xs"
            style="height: 30px;"
          />
        </span>
        <span v-else>
          <font-awesome-icon icon="times" class="text-danger pl-3" size="xs" style="height: 30px;"
        /></span>
      </div>
    </div>
  </div>
</template>
<script>
import { defaultSansVoteMajorityId } from "@/constants/default.js";
import { meetingResolutionStatuses } from "@/constants/meeting-resolution.js";
export default {
  props: [
    "majorityName",
    "voteOrder",
    "parentResolutionNumber",
    "resolution",
    "parentResolutionName",
  ],
  data() {
    return {
      defaultSansVoteMajorityId,
      meetingResolutionStatuses,
    };
  },
};
</script>
